import { GUIDELINES } from "@/common/constants";
import { getPartnerConfig } from "@/common/partnerConfig";
import Button from "@/components/Button";
import ButtonLink from "@/components/ButtonLink";
import Page from "@/components/Page";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function Guidelines() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const placeRef = window.localStorage.getItem("placeRef");
  const partnerConfig = getPartnerConfig(placeRef);
  const translationSuffix = partnerConfig?.guidelines.customTranslationSuffix ?? "";

  const guidelines = partnerConfig?.guidelines.showSubjectGuideline
    ? GUIDELINES
    : GUIDELINES.slice(0, 3);

  return (
    <Page
      lngChange
      title={t("guidelines.title")}
      back
      action={
        <Button onPress={() => navigate(-1)}>{t("guidelines.buttonTextAlt")}</Button>
      }
    >
      <div className="mx-auto my-12 max-w-3xl space-y-2 px-4 text-center">
        <p className="text-justify">{t("guidelines.welcome.description")}</p>
      </div>
      <ul className="mx-auto flex h-full w-full max-w-96 flex-col items-center justify-center gap-10 rounded-3xl border border-medium-gray bg-dark-gray px-4 py-6">
        {guidelines.map(({ Icon, titleKey, labelKey }, i) => (
          <li
            key={i}
            className="grid w-full grid-cols-[auto_1fr] items-center justify-evenly gap-4 text-foreground"
          >
            <Icon
              size={64}
              className="rounded-3xl bg-medium-gray/50 fill-foreground p-4 shadow-[inset_0_0px_10px_rgba(255,255,255,0.3),inset_0_-2px_4px_rgba(0,0,0,0.2)]"
            />
            <div className="w-full text-start">
              <h3 className="mb-1 text-lg font-semibold">{t(titleKey)}</h3>
              <p className="text-sm">
                {t(`${labelKey}${translationSuffix}`, { defaultValue: t(labelKey) })}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </Page>
  );
}
